import { ElementRef, EventEmitter, Input, OnChanges, Output, QueryList, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { IconComponent } from '../../common/components/general/icon/icon.component';
import { LinkButtonComponent } from '../../common/components/general/link-button/link-button.component';
import { eLinkButtonTarget } from '../../common/components/general/link-button/link-button.model';
import { CACHE_KEYS } from '../../common/constants/cache-keys';
import { UnreadNotificationsPipe } from '../../common/pipes/unread-notifications.pipe';
import { CacheService } from '../../common/services/cache.service';
import { NotificationsMenuService } from './notifications-menu.service';
import { NotificationLinkComponent } from '../../notification-tabs/notification-link/notification-link.component';
import { NotificationResults, NotificationsResponse } from './notifications-menu.viewmodel';
import { NgClass, NgIf } from '@angular/common';
import { ContentModel } from '../../common/models/content.model';
import { ContentFilterPipe } from '../../common/pipes/content-filter.pipe';
import { COMPONENT_META_DATA } from '../../common/constants/component-meta-data';
import { Router } from '@angular/router';
import { LPMI_ROUTES } from '../../common/constants/routes';
import { ElementsService } from '../../common/services/elements.service';
import { SharedMenuService } from '../shared-menu.service';
import { GtmEvent } from '../../common/models/gtm-event.model';
import { GtmService } from '../../common/services/gtm/gtm.service';

@Component({
  selector: 'nuc-notifications-menu',
  providers: [UnreadNotificationsPipe],
  imports: [IconComponent, MatTabsModule, MatMenuModule, LinkButtonComponent, NotificationLinkComponent, ContentFilterPipe, NgClass],
  templateUrl: './notifications-menu.component.html',
  styleUrl: './notifications-menu.component.scss'
})
export class NotificationsMenuComponent implements OnInit, AfterViewInit, OnChanges {
  eLinkButtonTargets = eLinkButtonTarget;
  @ViewChild(MatMenuTrigger) notificationMenuTrigger!: MatMenuTrigger;
  // @ViewChild('ringtone') notificationIcon!: QueryList<ElementRef>;;
  allNotifications: NotificationResults[];
  topNotifications: NotificationResults[];
  unreadNotifications: NotificationResults[];
  hasUnreadNotifications: boolean = false;
  userName: string;
  @Input() displayClass: string;
  @Input() pageContent: ContentModel[];
  @Input() size: string;
  @Input() showNotificationIcon: boolean;
  LABELS = COMPONENT_META_DATA.HEADER.LABELS;
  @Input() notificationsMobileMenu: boolean;
  @Input() desktopOverlayState: boolean = false;
  constructor(private notificationsService: NotificationsMenuService, private cacheService: CacheService, private unreadNotificationsPipe: UnreadNotificationsPipe,
    private router: Router, private elementsService: ElementsService, private sharedMenuService: SharedMenuService, private gtm: GtmService
  ) { }

  ngOnInit(): void {
    const loginData = this.cacheService.getFromCache(CACHE_KEYS.LOGIN.LOGIN_DATA);
    this.userName = loginData?.userName;
    if(this.showNotificationIcon){
    this.notificationsService.startNotificationsPolling();
    this.handleNotifications();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['showNotificationIcon']) {
      if(this.showNotificationIcon){
        this.notificationsService.startNotificationsPolling();
        this.handleNotifications();
      }
    }
    if (changes['notificationsMobileMenu']) {
      if(!this.notificationsMobileMenu){
        this.notificationMenuTrigger?.closeMenu();
      }
    }

    if (changes['desktopOverlayState']) {
      this.notificationMenuTrigger?.closeMenu();
    }
  }

  fetchNotifications(redirect?: boolean, event?: Event) {
    event?.stopPropagation();
    if(redirect){
      const gtmEvent = GtmEvent.create("HEADER", 'Header', 'Redirection::Internal', "Notifications::ViewMore");
      this.gtm.pushEvent(gtmEvent);
    }
    else{
      const gtmEvent = GtmEvent.create("HEADER", 'Header', 'Display::Notifications', "Notifications");
      this.gtm.pushEvent(gtmEvent);
    }  
    this.sharedMenuService.toggleMenu('notifications', this.notificationMenuTrigger?.menuOpen);
    if (redirect) {
      if (!this.elementsService.isEmbeddedInAngularApp) {
        window.location.href = `/${LPMI_ROUTES.NOTIFICATION.PATH}`;
      } else {
        this.router.navigate(['/' + LPMI_ROUTES.NOTIFICATION.PATH]);
      }
    }
    else {
      this.notificationsService.triggerNotificationsAdhoc();
    }
  }

  handleNotifications() {
    this.notificationsService.getNotifications().subscribe((data: NotificationsResponse) => {
      this.allNotifications = data.results;
      this.hasUnreadNotifications = !!this.allNotifications?.find(n => n.isRead === false);
      this.unreadNotifications = this.unreadNotificationsPipe.transform(this.allNotifications);
      this.topNotifications = this.unreadNotifications?.slice(0, 5);
    });
  }

  ngAfterViewInit(): void {
    this.notificationMenuTrigger.menuOpened.subscribe(() => {
      document.querySelector('.cdk-overlay-container')?.classList.add('custom-notification-menu-styles');
      const notificationIcons = document.querySelectorAll('.notification-icon-wrapper .ringtone-icon');
      notificationIcons.forEach(icon => icon.classList.add('selected'));

    });
    this.notificationMenuTrigger.menuClosed.subscribe(() => {
      setTimeout(() => {
        document.querySelector('.cdk-overlay-container')?.classList.remove('custom-notification-menu-styles');
        const notificationIcons = document.querySelectorAll('.notification-icon-wrapper .ringtone-icon');
        notificationIcons.forEach(icon => icon.classList.remove('selected'));
      }, 100);
    });
  }

}